import { useEffect, useState } from 'react';
import { getStorageValue } from '@portal-internet/core';
import { useData } from 'hooks/useData';
import ItemPrevisioRecent from './ItemPrevisioRecent';
import Slider from 'components/3catinfo/Slider';
import { useScript } from 'hooks/useScript';
import __isEmpty from 'lodash/isEmpty';
import styles from './previsioRecents.module.scss';

const mergeForecasts = (forecast1, forecast2, limit) => {
    const mergedArray = [...forecast1, ...forecast2]
        .reduce((map, item) => {
            map.set(item.id, item);
            return map;
        }, new Map())
        .values();

    return Array.from(mergedArray).slice(0, limit);
};

const PrevisioRecents = (props) => {
    const { previsionsProvincies, titol } = props;

    const { isJavaScriptClientEnabled } = useScript();

    const { data: visitedForecasts, getDades: getVisitedForecasts } = useData();
    const urlBase =
        '%%dataResources.apiCCMA%%/meteo?_format=json&origen=previsio&id=__VISITED_FORECAST__&version=2.0&pagina=1&cache=90';

    const [allForecasts, setAllForecasts] = useState(!isJavaScriptClientEnabled ? previsionsProvincies : []);

    useEffect(() => {
        const getVisitedCities = async () => {
            const idForecasts = await getStorageValue('_ccma_meteo_previsions');

            if (__isEmpty(idForecasts)) {
                setAllForecasts([...previsionsProvincies]);
            } else {
                const urlDades = urlBase.replace('__VISITED_FORECAST__', idForecasts.filter((item) => item).join(','));
                getVisitedForecasts(urlDades);
            }
        };

        getVisitedCities();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setAllForecasts(
            mergeForecasts(
                visitedForecasts.map((item) => {
                    return { ...item, cercaRecent: true };
                }),
                previsionsProvincies,
                8
            )
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visitedForecasts]);

    const tallarText = (text, longitut) => {
        const nouText = text.substring(0, longitut);
        const ultimEspai = nouText.lastIndexOf(' ');
        let char = nouText[ultimEspai - 1];
        let _end = ultimEspai;
        if (char === ',' || char === ':' || char === '.') {
            _end--;
        }
        return [`${nouText.substring(0, _end)}...`];
    };

    // Funció auxiliar per processar cada item (canvi mínim)
    const renderForecastItem = (item, index) => {
        const { id, nom, prev, cercaRecent } = item;
        if (__isEmpty(prev)) return <span key={`empty-${id}`}></span>;

        const { min, max, img_a, text_curt } = prev[0];
        const processedNom = nom.length > 35 ? tallarText(nom, 35) : nom;
        const processedText = nom.length > 17 && text_curt.length > 20 ? tallarText(text_curt, 20) : text_curt;

        return (
            <ItemPrevisioRecent
                key={`item-previsions-recents-${id}`}
                id={id}
                nom={processedNom}
                min={min}
                max={max}
                icona={img_a}
                text={processedText}
                cercaRecent={cercaRecent && index === 0}
            />
        );
    };

    return !__isEmpty(allForecasts) ? (
            <div className={styles.contPrevisions}>
                <Slider
                    format='previsionsRecents'
                    estilModul='previsionsRecents'
                    className='aspectAuto'
                    fletxes='mig'
                    titol={`Carrusel: ${titol}`}
                    noTitol={true}
                >
                    {allForecasts.map(renderForecastItem)}
                </Slider>
            </div>
    ) : (
        <></>
    );
};

export default PrevisioRecents;
